import { render, staticRenderFns } from "./company_index.vue?vue&type=template&id=54311160&scoped=true"
import script from "./company_index.vue?vue&type=script&lang=js"
export * from "./company_index.vue?vue&type=script&lang=js"
import style0 from "./company_index.vue?vue&type=style&index=0&id=54311160&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54311160",
  null
  
)

export default component.exports